export const brandsPriority = [
    {
        id:null,
        name:'Fanatics',
        logo:process.env.PUBLIC_URL + '/brands/fanatics.jpeg',
    },
    {
        id:null,
        name:'Fabletics',
        logo:process.env.PUBLIC_URL + '/brands/Fabletics.png',
    },
    {
        id:null,
        name:'Raising Canes',
        logo:process.env.PUBLIC_URL + '/brands/raisingcanes.jpg',
    },
    {
        id:null,
        name:'Snapchat',
        logo:process.env.PUBLIC_URL + '/brands/snapchat.png',
    },
    {
        id:null,
        name:"Sprouts Farmer's Market",
        logo:process.env.PUBLIC_URL + '/brands/sprouts.png',
    },
    {
        id:null,
        name:"Leaf Trading Cards",
        logo:process.env.PUBLIC_URL + '/brands/leaf.png',
    },
    {
        id:null,
        name:"ShpGld",
        logo:process.env.PUBLIC_URL + '/brands/shpgld.jpeg',
    },
    {
        id:null,
        name:"Samsung",
        logo:process.env.PUBLIC_URL + '/brands/samsung.png',
    },
    {
        id:null,
        name:"Firehouse Subs",
        logo:process.env.PUBLIC_URL + '/brands/firehouse.png',
    },
    {
        id:null,
        name:"1st Phorm",
        logo:process.env.PUBLIC_URL + '/brands/phorm.jpeg',
    },
    {
        id:null,
        name:"Dr Scholl's",
        logo:process.env.PUBLIC_URL + '/brands/scholls.png',
    },
    {
        id:null,
        name:"Prozis",
        logo:process.env.PUBLIC_URL + '/brands/prozis.jpeg',
    },
    {
        id:null,
        name:"Windsor",
        logo:process.env.PUBLIC_URL + '/brands/windsor.jpeg',
    },
    {
        id:null,
        name:"BPN",
        logo:process.env.PUBLIC_URL + '/brands/BPN.jpg',
    },
    {
        id:null,
        name:"Naked Nutrition",
        logo:process.env.PUBLIC_URL + '/brands/naked.png',
    },
    {
        id:null,
        name:"Primal Bowls",
        logo:process.env.PUBLIC_URL + '/brands/primalbowls.png',
    },
    {
        id:null,
        name:'Next Gen America',
        logo:process.env.PUBLIC_URL + '/brands/NextGenAmerica.png',
    },
]

export const brandsLowPriority = [
    {
        id:null,
        name:"Kyle Cavan",
        logo:process.env.PUBLIC_URL + '/brands/kylecavan.png',
    },
    {
        id:null,
        name:'Reco',
        logo:process.env.PUBLIC_URL + '/brands/RECO.jpeg',
    },
    {
        id:null,
        name:'GoFundMe',
        logo:process.env.PUBLIC_URL + '/brands/GoFundMe.jpeg',
    },
    {
        id:null,
        name:"Jerpa",
        logo:process.env.PUBLIC_URL + '/brands/Jerpa.jpeg',
    },{
        id:null,
        name:"Dormify",
        logo:process.env.PUBLIC_URL + '/brands/dormify.png',
    },
    {
        id:null,
        name:"Edikted",
        logo:process.env.PUBLIC_URL + '/brands/edikted.png',
    },{
        id:null,
        name:"STAAS Apparel",
        logo:process.env.PUBLIC_URL + '/brands/Staas.jpeg',
    },
    {
        id:null,
        name:"Plato's Closet",
        logo:process.env.PUBLIC_URL + '/brands/platos.png',
    },{
        id:null,
        name:"Sideline",
        logo:process.env.PUBLIC_URL + '/brands/sideline.png',
    },
    {
        id:null,
        name:"Champs Raise",
        logo:process.env.PUBLIC_URL + '/brands/champsraise.png',
    },
    {
        id:null,
        name:"American Gold Star Families",
        logo:process.env.PUBLIC_URL + '/brands/goldstart.jpeg',
    },
    {
        id:null,
        name:"Fast Twitch",
        logo:process.env.PUBLIC_URL + '/brands/fasttwitch.jpeg',
    },{
        id:null,
        name:"Clearalif",
        logo:process.env.PUBLIC_URL + '/brands/clearalif.png',
    },
    {
        id:null,
        name:"SEFI",
        logo:process.env.PUBLIC_URL + '/brands/sefi.png',
    },
    {
        id:null,
        name:"HockeyTday",
        logo:process.env.PUBLIC_URL + '/brands/TDAY.jpeg',
    },
    {
        id:null,
        name:"Kicks by Paige",
        logo:process.env.PUBLIC_URL + '/brands/kicksbypaige.jpeg',
    },{
        id:null,
        name:"UNDRDOG ATHLETIX",
        logo:process.env.PUBLIC_URL + '/brands/UDX.png',
    },
    {
        id:null,
        name:"Chill Life",
        logo:process.env.PUBLIC_URL + '/brands/chilllife.png',
    },
    {
        id:null,
        name:"Beaubble",
        logo:process.env.PUBLIC_URL + '/brands/beaubble.png',
    },
    {
        id:null,
        name:"Whatever Apparel",
        logo:process.env.PUBLIC_URL + '/brands/whatever.png',
    },
    {
        id:null,
        name:"Roots",
        logo:process.env.PUBLIC_URL + '/brands/roots.png',
    },
]
